export const PUBLIC = 'PUBLIC';
export const PRIVATE = 'PRIVATE';
export const GUILD = 'GUILD';
